module.exports = __webpack_public_path__ + "32297f97d424378ea25082a0aa5d3427.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-26.png
// module id = 2012
// module chunks = 0